const apiUrl = process.env.VUE_APP_API_URL + '/api'
const apiUrlRoot = process.env.VUE_APP_API_URL;
export { apiUrl, apiUrlRoot }
